"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoriaData = exports.FetchCategoria = void 0;
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var header = [
    { title: 'Username', prop: 'username' },
    { title: 'Name', prop: 'realname' },
    { title: 'Location', prop: 'location' }
];
var body = Array.from(new Array(57), function () {
    var rd = (Math.random() * 10).toFixed(1);
    return {
        username: 'john-nhoj',
        realname: "John " + rd,
        location: 'Saturn'
    };
});
var FetchCategoria = /** @class */ (function (_super) {
    __extends(FetchCategoria, _super);
    function FetchCategoria(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { dtoList: [], loading: true };
        fetch('http://localhost:5220/api/Catalog/Categorias')
            .then(function (response) { return response.json(); })
            .then(function (data) {
            _this.setState({ dtoList: data, loading: false });
        });
        // This binding is necessary to make "this" work in the callback  
        _this.handleDelete = _this.handleDelete.bind(_this);
        _this.handleEdit = _this.handleEdit.bind(_this);
        return _this;
    }
    FetchCategoria.prototype.render = function () {
        var contents = this.state.loading
            ? React.createElement("p", null,
                React.createElement("em", null, "Loading..."))
            : this.renderCategoriaTable(this.state.dtoList);
        return React.createElement("div", null,
            React.createElement("h1", null, "Categorias Data"),
            React.createElement("p", null, "This component demonstrates fetching Employee data from the server."),
            React.createElement("p", null,
                React.createElement(react_router_dom_1.Link, { to: "/add-categoria" }, "Create New")),
            contents);
    };
    // Handle Delete request for an employee  
    FetchCategoria.prototype.handleDelete = function (id) {
        var _this = this;
        //if (!confirm("Do you want to delete employee with Id: " + id))
        if (id == 0)
            return;
        else {
            fetch('http://localhost:5220/api/Catalog/Categorias/' + id, {
                method: 'delete'
            }).then(function (data) {
                _this.setState({
                    dtoList: _this.state.dtoList.filter(function (rec) {
                        return (rec.idCategoria != id);
                    })
                });
            });
        }
    };
    FetchCategoria.prototype.handleEdit = function (id) {
        this.props.history.push("/categoria/edit/" + id);
    };
    // Returns the HTML table to the render() method.  
    FetchCategoria.prototype.renderCategoriaTable = function (dtoList) {
        var _this = this;
        return React.createElement("table", { className: 'table' },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null),
                    React.createElement("th", null, "IdCategoria"),
                    React.createElement("th", null, "Nombre"),
                    React.createElement("th", null, "Institucional"),
                    React.createElement("th", null, "Estado"),
                    React.createElement("th", null, "Ultimo Cambio"))),
            React.createElement("tbody", null, dtoList.map(function (dto) {
                return React.createElement("tr", { key: dto.idCategoria },
                    React.createElement("td", null),
                    React.createElement("td", null, dto.idCategoria),
                    React.createElement("td", null, dto.txNombreCategoria),
                    React.createElement("td", null, dto.bdInstitucional ? "Sí" : "No"),
                    React.createElement("td", null, dto.bdEstadoRegistro ? "Activo" : "Inactivo"),
                    React.createElement("td", null, dto.dtUltimoCambio),
                    React.createElement("td", null,
                        React.createElement("a", { className: "action", onClick: function (id) { return _this.handleEdit(dto.idCategoria); } }, "Edit"),
                        "  |",
                        React.createElement("a", { className: "action", onClick: function (id) { return _this.handleDelete(dto.idCategoria); } }, "Delete")));
            })));
    };
    return FetchCategoria;
}(React.Component));
exports.FetchCategoria = FetchCategoria;
var CategoriaData = /** @class */ (function () {
    function CategoriaData() {
        this.idCategoria = 0;
        this.txNombreCategoria = "";
        this.bdInstitucional = false;
        this.bdEstadoRegistro = false;
        this.dtUltimoCambio = new Date().toISOString();
        this.rowVersion = "";
    }
    return CategoriaData;
}());
exports.CategoriaData = CategoriaData;
//# sourceMappingURL=FetchCategoria.js.map